import { useTranslate } from '@va/localization';
import { SingleSelectFilter } from '@va/shared/feature-filters';
import { Filter } from '@va/types/filters';
import { useMemo } from 'react';

export const usePollsAndSurveysFilterOptions = () => {
  const translate = useTranslate();

  const filterOptions: Filter[] = useMemo(
    () => [
      new SingleSelectFilter({
        id: '1',
        label: translate('filters.options.status'),
        name: 'status',
        inputProps: {
          useOptions: () => ({
            data: [
              { label: translate('behaviourStatus.Active'), value: 3 },
              { label: translate('behaviourStatus.Drafts'), value: 2 },
              { label: translate('behaviourStatus.Inactive'), value: 1 },
            ],
          }),
        },
      }),
    ],
    [translate],
  );

  return filterOptions;
};
